import React from "react";
import styled from "styled-components";
import { XMasonry, XBlock } from "react-xmasonry";
import componentQueries from "react-component-queries";

const Container = styled.div`
  width: 100%;
  height: 100%;
`;

const Element = styled.div`
  font-size: 2rem;
  padding: ${({ gutter }) => gutter};
`;

const parseCssUnit = str => {
  const num = parseFloat(str, 10);
  return [num, str.match(/[\d.\-+]*\s*(.*)/)[1] || ""];
};

const Masonry = componentQueries({
  queries: [
    ({ width }, { columns = 2 }) => {
      return {
        targetBlockWidth: width / columns
      };
    }
  ],
  config: {
    refreshRate: 50
  }
})(
  class extends React.Component {
    state = {
      resizing: false
    };

    componentWillReceiveProps(nextProps) {
      if (this.props.targetBlockWidth !== nextProps.targetBlockWidth) {
        this.setState({
          resizing: true
        });
        if (this.resizeDone) {
          clearTimeout(this.resizeDone);
        }
        this.resizeDone = setTimeout(() => {
          this.setState({
            resizing: false
          });
        }, 500);
      }
    }

    render() {
      const { resizing } = this.state;
      if (resizing) {
        return <Container />;
      }

      const {
        targetBlockWidth,
        elements,
        gutter: gutterProp = "0px"
      } = this.props;
      const [val, unit] = parseCssUnit(gutterProp);
      const gutter = [val / 2, unit].join("");
      const blocks = elements.map(({ element, span = 1 }, i) => {
        return (
          <XBlock key={i} width={span}>
            <Element gutter={gutter}>{element}</Element>
          </XBlock>
        );
      });
      return (
        <Container>
          <XMasonry
            center={false}
            ref={x => {
              this.x = x;
            }}
            smartUpdate
            responsive={false}
            targetBlockWidth={targetBlockWidth}
          >
            {blocks}
          </XMasonry>
        </Container>
      );
    }
  }
);

export default Masonry;



// WEBPACK FOOTER //
// ./src/components/masonry.js